<template>
  <el-dialog
    :visible.sync="dialogAddBookingVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="dialogClose"
    width="800px"
  >
    <div slot="title" class="dialog-title">
      {{ formTypesTitle[formType] }}
    </div>
    <el-form
      :model="addBookingForm"
      :rules="addBookingFormRule"
      ref="addBookingForm"
      label-width="128px"
      class="add-booking-form"
      @click.capture.native="hidePosPop"
    >
      <el-form-item label="手艺人" v-if="formType == 'occupy'">
        <el-select
          v-model="addBookingForm.workUserId"
          size="small"
          placeholder="请选择手艺人"
          clearable
          @change="findArtisansAppointmentStatus"
        >
          <el-option
            v-for="item in artisansList"
            :key="item.workUserId"
            :label="item.nickName"
            :value="item.workUserId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="phoneNum" v-if="!formType || formType == 'add'">
        <el-input
          class="width260"
          v-model="addBookingForm.phoneNum"
          placeholder="请填写手机号"
          size="small"
        >
          <!-- <el-select v-model="areaCode" slot="prepend" placeholder="请选择">
            <el-option-group
              v-for="group in areaCodeList"
              :key="group.code"
              :label="group.zh"
            >
              <el-option
                v-for="item in group.options"
                :key="item.en"
                :label="`${item.zh} +${item.code}`"
                :value="item.code"
              >
                <span style="float: left;">{{ item.zh }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;"
                  >+{{ item.code }}</span
                >
              </el-option>
            </el-option-group>
          </el-select> -->
        </el-input>
      </el-form-item>
      <el-form-item
        label="到店人"
        prop="peopleName"
        v-if="!formType || formType == 'add'"
      >
        <el-input
          class="width260"
          v-model="addBookingForm.peopleName"
          placeholder="请填写到店人姓名"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="下单人"
        v-if="formType && formType != 'add' && formType != 'occupy'"
      >
        {{ addBookingForm.phoneNum }} {{ addBookingForm.peopleName }}
      </el-form-item>
      <el-form-item
        label="到店人"
        v-if="formType && formType != 'add' && formType != 'occupy'"
      >
        {{ addBookingForm.phoneNum }} {{ addBookingForm.peopleName }}
      </el-form-item>
      <el-form-item
        label="服务和手艺人"
        style="position: relative"
        v-if="formType == 'add' && !isAddUnassigned"
      >
        <el-table
          v-if="addBookingForm.bookingList.length"
          border
          :data="addBookingForm.bookingList"
          style="width: 100%"
        >
          <el-table-column label="手艺人">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.workUserId"
                size="small"
                placeholder="请选择手艺人"
                @change="findArtisansAppointmentStatus('worker')"
                clearable
              >
                <el-option
                  v-for="item in artisansList"
                  :key="item.workUserId"
                  :label="item.nickName"
                  :value="item.workUserId"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="预约服务">
            <template slot-scope="scope">
              <div v-if="!scope.row.workUserId">请选择手艺人</div>
              <template v-else>
                <div v-if="scope.row.goodsId" class="service-info">
                  <p>{{ scope.row.serviceInfo.label }}</p>
                  <p v-if="scope.row.serviceInfo.otherLabel">
                    {{ scope.row.serviceInfo.otherLabel }}
                  </p>
                  <p>服务:约{{ scope.row.serviceInfo.serviceTime }}分钟</p>
                </div>
                <el-button
                  v-else
                  type="primary"
                  plain
                  size="mini"
                  class="add-button"
                  @click.capture="addBookingList"
                  >添加服务</el-button
                >
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template>
              <el-button
                v-if="addBookingForm.orderType != 0"
                type="text"
                @click="delBookingList"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        label="服务和手艺人"
        style="position: relative"
        v-else-if="(formType != 'detail' && formType != 'occupy') || isAddUnassigned"
      >
        <el-table
          v-if="addBookingForm.bookingList.length"
          border
          :data="addBookingForm.bookingList"
          style="width: 100%"
        >
          <el-table-column label="预约服务">
            <template slot-scope="scope">
              <div v-if="scope.row.goodsId" class="service-info">
                <p>{{ scope.row.serviceInfo.label }}</p>
                <p v-if="scope.row.serviceInfo.otherLabel">
                  {{ scope.row.serviceInfo.otherLabel }}
                </p>
                <p>服务:约{{ scope.row.serviceInfo.serviceTime }}分钟</p>
              </div>
              <el-button
                v-else
                type="primary"
                plain
                size="mini"
                class="add-button"
                @click.capture="addBookingList"
                >添加服务</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="手艺人">
            <template slot-scope="scope">
              <div v-if="!scope.row.goodsId">请选择服务</div>
              <el-select
                v-else
                v-model="scope.row.workUserId"
                size="small"
                placeholder="请选择手艺人"
                @change="findArtisansAppointmentStatus('worker')"
                clearable
              >
                <el-option
                  v-for="item in artisansList"
                  :key="item.workUserId"
                  :label="item.nickName"
                  :value="item.workUserId"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template>
              <el-button
                v-if="addBookingForm.orderType != 0"
                type="text"
                @click="delBookingList"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        label="服务和手艺人"
        style="position: relative"
        v-if="formType == 'detail'"
      >
        <el-table border :data="addBookingForm.bookingList" style="width: 100%">
          <el-table-column label="预约服务">
            <template slot-scope="scope">
              <div v-if="scope.row.goodsId" class="service-info">
                <p>{{ scope.row.serviceInfo.label }}</p>
                <p v-if="scope.row.serviceInfo.otherLabel">
                  {{ scope.row.serviceInfo.otherLabel }}
                </p>
                <p>服务:约{{ scope.row.serviceInfo.serviceTime }}分钟</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手艺人">
            <template slot-scope="scope">
              <el-select
                :disabled="true"
                v-model="scope.row.workUserId"
                size="small"
                placeholder="请选择手艺人"
                clearable
              >
                <el-option
                  v-for="item in artisansList"
                  :key="item.workUserId"
                  :label="item.nickName"
                  :value="item.workUserId"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="开始时间" v-if="formType == 'occupy'">
        <el-date-picker
          v-model="addBookingForm.appointmentDate"
          type="date"
          placeholder="选择到店日期"
          size="small"
          :picker-options="pickerOptions"
          @change="findArtisansAppointmentStatus('date')"
        >
        </el-date-picker>
        <el-button
          :type="addBookingForm.startTime ? 'primary' : 'danger'"
          plain
          size="small"
          class="sel-time-button"
          @click.capture="addTime"
          >{{
            addBookingForm.startTime ? `${addBookingForm.startTime}` : "选择时间"
          }}</el-button
        >
      </el-form-item>
      <el-form-item label="占用时长" v-if="formType != 'detail'">
        <div class="hour-minute">
          <el-input
            placeholder="请输入"
            v-model="addBookingForm.hourStep"
            size="small"
            @input.native="hourInputChange($event)"
          >
            <template slot="append">小时</template>
          </el-input>
          <el-input
            placeholder="请输入"
            v-model="addBookingForm.minuteStep"
            size="small"
            @input.native="minuteInputChange($event)"
          >
            <template slot="append">分钟</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="到店时间" v-if="formType != 'detail' && formType != 'occupy'">
        <el-date-picker
          v-model="addBookingForm.appointmentDate"
          type="date"
          placeholder="选择到店日期"
          size="small"
          :picker-options="pickerOptions"
          @change="findArtisansAppointmentStatus('date')"
        >
        </el-date-picker>
        <el-button
          :type="addBookingForm.startTime ? 'primary' : 'danger'"
          plain
          size="small"
          class="sel-time-button"
          @click.capture="addTime"
          >{{
            addBookingForm.startTime
              ? `${addBookingForm.startTime} - ${addBookingForm.endTime}`
              : "选择时间"
          }}</el-button
        >
      </el-form-item>
      <el-form-item label="商家备注" v-if="formType != 'detail'">
        <el-input
          type="textarea"
          v-model="addBookingForm.shoperRemark"
          placeholder="商家备注不超过200个字"
          :rows="5"
          resize="none"
        ></el-input>
      </el-form-item>
      <el-form-item label="到店时间" v-if="formType == 'detail'">
        {{ addBookingForm.appointmentDate }} {{ addBookingForm.startTime }}
      </el-form-item>
      <el-form-item label="商家备注" v-if="formType == 'detail'">
        {{ addBookingForm.shoperRemark }}
      </el-form-item>
      <el-form-item label="买家备注" v-if="formType == 'detail'">
        {{ addBookingForm.buyerReMark }}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="saveOrUpdateAppointmentOrder"
        :loading="isSubmit"
        v-if="formType != 'detail'"
        >确认</el-button
      >
      <el-button type="primary" @click="dialogAddBookingVisible = false" v-else plain
        >关闭</el-button
      >
    </div>
    <div
      :style="{
        left: `${popLeft}px`,
        top: `${popTop}px`,
      }"
      class="position-pop service-list"
      v-if="isShowBookingPosPop"
    >
      <div class="pop-container">
        <div class="header">
          <el-select
            popper-class="screen-select"
            v-model="menuSel"
            size="small"
            placeholder="请选择服务分类"
            clearable
          >
            <el-option
              v-for="item in menuList"
              :key="item.goodsCategoryId"
              :label="item.categoryName"
              :value="item.goodsCategoryId"
            >
            </el-option>
          </el-select>
          <el-input
            placeholder="请输入服务名称..."
            v-model.trim="searchInput"
            class="input-search"
            size="small"
            @keyup.enter.native="searchGoods"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchGoods"
            ></el-button>
          </el-input>
        </div>
        <div class="list" v-loading="isLoadService">
          <div
            class="item"
            :class="{
              active: serviceSel === index,
            }"
            v-for="(item, index) in serviceList"
            :key="index"
            :title="item.goodsId"
            @click="onServiceSel(index)"
          >
            <p>
              {{ item.label }}
            </p>
            <div class="right">
              <p>￥{{ item.retailPrice }}</p>
              <p>约{{ item.serviceTime }}分钟</p>
            </div>
            <i class="el-icon-caret-bottom" v-if="item.subList.length"></i>
            <div class="sublist">
              <div
                class="sub-item"
                v-for="subitem in item.subList"
                :key="subitem.otherLabel"
                @click="onServiceSubSel(subitem)"
              >
                <span>{{ subitem.label }} {{ subitem.otherLabel }}</span>
                <span>￥{{ subitem.retailPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :style="{
        left: `${popLeft}px`,
        top: `${popTop}px`,
      }"
      class="position-pop time-list"
      v-if="isShowTimePosPop"
    >
      <div class="pop-container">
        <div class="list" v-loading="isLoad">
          <div
            class="item"
            v-for="(item, index) in timeList"
            :key="item.value"
            :class="item.className"
            @click="selTime(index)"
          >
            <div v-if="item.label.indexOf('次日') != -1">
              <p>次日</p>
              <p>{{ item.label.split("]")[1] }}</p>
            </div>
            <div v-else>
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="footer">
          <span
            >{{ formType == "occupy" ? "到店时间：" : "预约时间："
            }}<span :class="!addBookingForm.startTime ? 'unsel' : 'sel'">{{
              !addBookingForm.startTime
                ? "请选择"
                : `${
                    formType == "occupy"
                      ? `${addBookingForm.startTime}`
                      : `${addBookingForm.startTime} - ${addBookingForm.endTime}`
                  } `
            }}</span></span
          >
          <el-button type="primary" size="small" @click="isShowTimePosPop = false"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import areaCodeList from "@/assets/js/code.json";
import {
  getFindAllGoodsPlus,
  getEdcShopGoodsCategorys,
  findArtisans,
  schedulingList,
  findConfigByShopId,
  findArtisansAppointmentStatus,
  saveOrUpdateAppointmentOrder,
  appointmentOrderList,
  updateAppointmentOrderStatus,
} from "@/api/index.js";
let timeIntervalNum = 15;
let timeDisaled = 1;
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      formType: "",
      formTypesTitle: {
        "": "添加预约",
        add: "添加预约",
        edit: "编辑预约",
        detail: "预约详情",
        occupy: "添加占用",
      },
      searchInput: "",
      areaCodeList: areaCodeList,
      areaCode: 86,
      popLeft: 0,
      popTop: 0,
      isShowBookingPosPop: false,
      serviceList: [],
      serviceSel: "",
      menuList: [],
      menuSel: "",
      artisansList: [],
      isLoad: false,
      isLoadService: false,
      timeList: [],
      baseTimeList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      isShowTimePosPop: false,
      dialogAddBookingVisible: false,
      addBookingForm: {
        phoneNum: "",
        peopleName: "",
        bookingList: [
          {
            serviceInfo: {
              label: "",
              serviceTime: "",
            },
            goodsId: "",
            productId: "",
            workUserId: "",
          },
        ],
        appointmentDate: new Date(),
        hourStep: 1,
        minuteStep: 0,
        startTime: "",
        endTime: "",
        shoperRemark: "",
      },
      addBookingFormRule: {
        phoneNum: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
        ],
        peopleName: [
          {
            required: true,
            message: "请填写到店人姓名 ",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "选择时间",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
      isAddUnassigned: false,
    };
  },
  watch: {
    menuSel() {
      this.getServiceList();
    },
  },
  mounted() {
    if (this.addBookingForm.bookingList.length) {
      this.$watch(
        function () {
          return (
            this.addBookingForm.bookingList.length &&
            this.addBookingForm.bookingList[0].serviceInfo
          );
        },
        function (res) {
          console.log(">>>>serviceInfo", res);
          if (!res || !res.serviceTime || this.addBookingForm.endTime) return;
          this.addBookingForm.hourStep = parseInt(res.serviceTime / 60);
          this.addBookingForm.minuteStep = parseInt(res.serviceTime % 60);
          this.stepInputChange();
        }
      );
    }
    this.formatTimeList();
  },
  methods: {
    delBookingList() {
      this.addBookingForm.bookingList = [
        {
          serviceInfo: {
            label: "",
            serviceTime: "",
          },
          goodsId: "",
          productId: "",
          workUserId: "",
        },
      ];
      this.addBookingForm.startTime = "";
      this.addBookingForm.endTime = "";
    },
    formatTimeList() {
      findConfigByShopId().then((res) => {
        // timeIntervalNum = res.data.appointTimeInterval;
        let timeInterval = timeIntervalNum * 60 * 1000;
        //   console.log(this.timeList);
        schedulingList({ row: 9999 }).then((res) => {
          if (res.code == 1) {
            let startTime = "";
            res.data.forEach((val) => {
              if (val.peopleNum) {
                if (
                  !startTime ||
                  !this.isLess(
                    +startTime,
                    val.startTime,
                    this.addBookingForm.appointmentDate
                  )
                ) {
                  startTime = new Date(
                    `${new Date().pattern("yyyy-MM-dd")} ${val.startTime}`
                  );
                }
              }
            });
            res.data.forEach((val) => {
              if (val.peopleNum) {
                let endTime = this.formatTime(
                  val.endTime,
                  this.addBookingForm.appointmentDate
                );
                console.log(startTime);
                let currentDay = new Date(startTime).getDate();
                let currentMonth = new Date(startTime).getMonth();
                while (startTime <= endTime) {
                  let stepTime = new Date(startTime);
                  let isNextDay =
                    stepTime.getDate() > currentDay || stepTime.getMonth() > currentMonth;
                  let findIndex = this.timeList.findIndex(
                    (ival) =>
                      ival.value ==
                      `${isNextDay ? "[次日]" : ""}${stepTime.pattern("HH:mm")}`
                  );
                  if (findIndex == -1) {
                    this.timeList.push({
                      value: `${isNextDay ? "[次日]" : ""}${stepTime.pattern("HH:mm")}`,
                      label: `${isNextDay ? "[次日]" : ""}${stepTime.pattern("HH:mm")}`,
                      peopleNum: val.peopleNum,
                      className: "",
                    });
                  } else {
                    if (this.timeList[findIndex].peopleNum < val.peopleNum) {
                      this.timeList[findIndex].peopleNum = val.peopleNum;
                    }
                  }
                  startTime = +startTime + timeInterval;
                  console.log(stepTime.pattern("HH:mm"), timeInterval / 60 / 1000);
                }
              }
            });
            this.timeList.sort((a, b) => {
              let startTime = a.value.split("]");
              if (startTime.length == 2) {
                startTime = new Date(
                  `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
                    "yyyy-MM-dd"
                  )} ${startTime[1].trim()}`
                );
              } else {
                startTime = new Date(
                  `${new Date().pattern("yyyy-MM-dd")} ${startTime[0].trim()}`
                );
              }
              let endTime = b.value.split("]");
              if (endTime.length == 2) {
                endTime = new Date(
                  `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
                    "yyyy-MM-dd"
                  )} ${endTime[1].trim()}`
                );
              } else {
                endTime = new Date(
                  `${new Date().pattern("yyyy-MM-dd")} ${endTime[0].trim()}`
                );
              }
              return +startTime > +endTime ? 1 : -1;
            });
            this.baseTimeList = this.timeList;
            console.log(this.baseTimeList, timeInterval / 1000 / 60);
            this.findArtisans("init");
          }
        });
      });
    },
    dialogClose() {
      this.isShowTimePosPop = false;
      this.isShowBookingPosPop = false;
      this.addBookingForm = {
        phoneNum: "",
        peopleName: "",
        bookingList: [
          {
            serviceInfo: {
              label: "",
              serviceTime: "",
            },
            goodsId: "",
            productId: "",
            workUserId: "",
          },
        ],
        appointmentDate: new Date(),
        hourStep: 1,
        minuteStep: 0,
        startTime: "",
        endTime: "",
        shoperRemark: "",
      };
      this.findArtisans("init");
      this.$refs.addBookingForm.resetFields();
    },
    showAddBooking(type = "add", json = null, time = "") {
      this.isAddUnassigned = false;
      this.formType = type;
      console.log(type, json);
      if (json) {
        this.addBookingForm = json;
      }
      if (time) {
        time = time.replace(" ", "");
      }
      if (type == "edit" || type == "detail") {
        if (json.bookingList.length && !json.bookingList[0].goodsId && type == "detail") {
          json.bookingList.pop();
        }
        if (json.bookingList.length) {
          if (json.bookingList[0].serviceInfo.specDesc) {
            let specDesc = json.bookingList[0].serviceInfo.specDesc.split("-");
            if (specDesc.length == 2) {
              json.bookingList[0].serviceInfo.specDesc = specDesc[1]
                .replace("(", "")
                .replace(")", "");
            }
          }
          this.getServiceList(json);
        }
      }
      if (type == "add") {
        if (json && json.workUserId && json.workUserId != -1) {
          this.addBookingForm.bookingList[0].workUserId = json.workUserId;
        }
        if (json && json.workUserId == -1) {
          this.isAddUnassigned = true;
        } else {
          this.findArtisansAppointmentStatus();
        }
        this.addBookingForm.startTime = time;
        this.computedTime(this.addBookingForm.startTime);
        this.getServiceList();
      }
      if (type == "occupy") {
        if (json.workUserId != -1) {
          this.addBookingForm.workUserId = json.workUserId;
          this.findArtisansAppointmentStatus();
        } else {
          this.addBookingForm.workUserId = "";
        }
        // this.formatArtisansAppointmentStatus(this.addBookingForm.workUserId);
        this.addBookingForm.startTime = time;
        this.computedTime(this.addBookingForm.startTime);
      }
      console.log(this.addBookingForm, json);
      this.dialogAddBookingVisible = true;
    },
    saveOrUpdateAppointmentOrder() {
      if (this.isSubmit) return;
      this.isSubmit = true;
      this.$refs.addBookingForm.validate((valid) => {
        if (valid) {
          console.log(this.addBookingForm);
          if (!this.addBookingForm.startTime) {
            this.isSubmit = false;
            return this.$message.error("请选择时间");
          }
          if (
            !Number(this.addBookingForm.hourStep) &&
            Number(this.addBookingForm.minuteStep) < 5
          ) {
            this.isSubmit = false;
            return this.$message.error("间隔时间应大于5分钟小于24小时");
          }
          let appointmentDate = new Date(this.addBookingForm.appointmentDate);
          if (this.formType == "occupy") {
            let params = {
              status: 2,
              workUserId: this.addBookingForm.workUserId,
              appointmentDate: appointmentDate.pattern("yyyy-MM-dd"),
              startTime: this.addBookingForm.startTime,
              endTime: this.addBookingForm.endTime,
              shoperRemark: this.addBookingForm.shoperRemark,
              shopMemberId: this.addBookingForm.shopMemberId || "",
              cashCouponId: this.addBookingForm.cashCouponId || "",
            };
            updateAppointmentOrderStatus(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "占用成功",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getPageData");
                this.dialogAddBookingVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            let params = {
              appointmentOrderId: this.addBookingForm.appointmentOrderId || "",
              phoneNum: this.addBookingForm.phoneNum,
              peopleName: this.addBookingForm.peopleName,
              goodsId: this.addBookingForm.bookingList[0].goodsId,
              productId: this.addBookingForm.bookingList[0].productId,
              workUserId: this.addBookingForm.bookingList[0].workUserId,
              appointmentDate: appointmentDate.pattern("yyyy-MM-dd"),
              startTime: this.addBookingForm.startTime,
              endTime: this.addBookingForm.endTime,
              shoperRemark: this.addBookingForm.shoperRemark,
              payMoney:
                this.addBookingForm.payMoney ||
                this.addBookingForm.bookingList[0].serviceInfo.retailPrice ||
                "",
              specDesc: this.addBookingForm.bookingList[0].serviceInfo.otherLabel || "",
              otherLabel: this.addBookingForm.bookingList[0].serviceInfo.otherLabel || "",
              shopMemberId: this.addBookingForm.shopMemberId || "",
              cashCouponId: this.addBookingForm.cashCouponId || "",
            };
            console.log(params);
            saveOrUpdateAppointmentOrder(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: this.formType == "add" ? "创建成功" : "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getPageData");
                this.dialogAddBookingVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          this.isSubmit = false;
          return false;
        }
      });
    },
    addBookingList() {
      this.menuSel = "";
      let rect = document.querySelector(`.add-button`).getBoundingClientRect();
      let offsetX = rect.left;
      let offsetY = rect.top + rect.height;
      this.popLeft = offsetX;
      this.popTop = offsetY + 10;
      this.serviceSel = "";
      this.isShowBookingPosPop = true;
      this.getServiceList();
      this.getEdcShopGoodsCategorys();
    },
    addTime() {
      let rect = document.querySelector(`.sel-time-button`).getBoundingClientRect();
      let offsetX = rect.left;
      let offsetY = rect.top + rect.height;
      this.popLeft = offsetX;
      this.popTop = offsetY + 10;
      this.isShowTimePosPop = true;
      this.filterTimeList();
      this.findArtisansAppointmentStatus();
    },
    hidePosPop() {
      this.isShowTimePosPop = false;
      this.isShowBookingPosPop = false;
    },
    findArtisansAppointmentStatus(type = "init") {
      console.log("findArtisansAppointmentStatus");
      this.$forceUpdate();
      this.addBookingForm.startTime = "";
      this.addBookingForm.endTime = "";
      if (type == "date") {
        this.addBookingForm.bookingList[0].workUserId = "";
        if (!this.isAddUnassigned && this.formType != "edit") {
          this.addBookingForm.bookingList[0].goodsId = "";
        }
        this.findArtisans();
      }
      if (!this.isAddUnassigned && this.formType != "edit" && type == "worker") {
        this.addBookingForm.bookingList[0].goodsId = "";
      }
      this.filterTimeList();
      if (
        !this.addBookingForm.bookingList[0].workUserId &&
        !this.addBookingForm.workUserId
      )
        return;
      this.formatArtisansAppointmentStatus(
        this.addBookingForm.bookingList[0].workUserId || this.addBookingForm.workUserId
      );
    },
    formatArtisansAppointmentStatus(workUserId) {
      this.isLoad = true;
      findArtisansAppointmentStatus({
        workUserId: workUserId,
        appointmentDate: new Date(this.addBookingForm.appointmentDate).pattern(
          "yyyy-MM-dd"
        ),
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          let timeDisabledIndex = 0;
          this.timeList.forEach((sval, sindex) => {
            let findIndex = res.data.timeList.findIndex((val) => {
              return val.time == sval.value.replace(" ", "");
            });
            console.log(findIndex, sval);

            sval.className = "";
            if (findIndex != -1) {
              console.log(
                "res.data.timeList[res.data.timeList.length - timeDisaled].time",
                res.data.timeList[
                  res.data.timeList.length - timeDisaled + timeDisabledIndex
                ].time,
                sval.value.replace(" ", ""),
                timeDisaled
              );
              if (
                res.data.timeList[
                  res.data.timeList.length - timeDisaled + timeDisabledIndex
                ].time == sval.value.replace(" ", "")
              ) {
                if (this.addBookingForm.startTime == sval.value.replace(" ", "")) {
                  this.addBookingForm.startTime = "";
                }
                this.timeList[sindex].className = "disabled";
                timeDisabledIndex++;
              }
              if (res.data.timeList[findIndex].appointmentStatus != 1) {
                sval.className = "occupy";
                if (this.addBookingForm.startTime == sval.value.replace(" ", "")) {
                  this.addBookingForm.startTime = "";
                }
                let i = 1;
                while (i <= timeDisaled && sindex - i > 0) {
                  if (this.timeList[sindex - i].className != "occupy") {
                    console.log(
                      this.addBookingForm.startTime,
                      this.timeList[sindex - i].value.replace(" ", ""),
                      this.addBookingForm.startTime ==
                        this.timeList[sindex - i].value.replace(" ", "")
                    );
                    if (
                      this.addBookingForm.startTime ==
                      this.timeList[sindex - i].value.replace(" ", "")
                    ) {
                      this.addBookingForm.startTime = "";
                    }
                    this.timeList[sindex - i].className = "disabled";
                  }
                  i++;
                }
              }
            } else {
              console.log(
                this.isBeInWorkTime(res.data.startTime, res.data.endTime, sval.value),
                sval.value
              );
              if (
                !this.isBeInWorkTime(res.data.startTime, res.data.endTime, sval.value)
              ) {
                sval.className = "disabled";
              }
            }
          });
          this.$forceUpdate();
          console.log(this.timeList);
        } else {
          this.timeList.forEach((sval) => {
            sval.className = "disabled";
          });
        }

        this.isLoad = false;
      });
    },
    isBeInWorkTime(startTime, endTime, value) {
      let comObj = value.split("]");
      if (comObj.length == 2) {
        comObj = new Date(
          `${new Date(
            +new Date(this.addBookingForm.appointmentDate) + 24 * 60 * 60 * 1000
          ).pattern("yyyy-MM-dd")} ${comObj[1].trim()}`
        );
      } else {
        comObj = new Date(
          `${new Date(this.addBookingForm.appointmentDate).pattern(
            "yyyy-MM-dd"
          )} ${comObj[0].trim()}`
        );
      }
      return Number(startTime) < value || Number(endTime) > value;
    },
    filterTimeList() {
      this.timeList = this.baseTimeList.filter((val) => {
        let nowDate = new Date();
        if (
          new Date(this.addBookingForm.appointmentDate).pattern("yyyy-MM-dd") !=
          nowDate.pattern("yyyy-MM-dd")
        ) {
          console.log(
            "not",
            new Date(this.addBookingForm.appointmentDate).pattern("yyyy-MM-dd"),
            nowDate.pattern("yyyy-MM-dd")
          );
          nowDate = new Date(`${nowDate.pattern("yyyy-MM-dd")} 00:00:00`);
        }
        let currentTime = val.value.split("]");
        if (currentTime.length == 2) {
          currentTime = new Date(
            `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
              "yyyy-MM-dd"
            )} ${currentTime[1].trim()}`
          );
        } else {
          currentTime = new Date(
            `${new Date().pattern("yyyy-MM-dd")} ${currentTime[0].trim()}`
          );
        }
        return currentTime > nowDate;
      });
      timeDisaled = Math.ceil(
        (this.addBookingForm.hourStep * 60 + Number(this.addBookingForm.minuteStep)) /
          timeIntervalNum
      );
      console.log(
        timeDisaled,
        this.addBookingForm.hourStep,
        this.addBookingForm.minuteStep
      );
      if (!timeDisaled) {
        timeDisaled = 1;
      }
      this.timeList.forEach((val, index) => {
        // val.className = "";
        console.log(1, val.className);
        if (val.className == "occupy") {
          console.log(2, val.className);
          let i = 1;
          while (i <= timeDisaled && index - i >= 0) {
            if (this.timeList[index - i].className != "occupy") {
              this.timeList[index - i].className = "disabled";
            }
            i++;
          }
        }
        if (this.timeList.length - timeDisaled <= index) {
          val.className = "disabled";
        }
      });
    },
    searchGoods() {
      this.getServiceList();
    },
    getServiceList(json) {
      this.isLoadService = true;
      getFindAllGoodsPlus({
        goodsNatureType: 2,
        goodsCategoryId: this.menuSel,
        pageNo: 1,
        row: 9999,
        goodsId: json ? json.bookingList[0].goodsId : "",
        goodsName: this.searchInput,
        workUserId: json
          ? ""
          : this.addBookingForm.bookingList[0].workUserId == -1
          ? ""
          : this.addBookingForm.bookingList[0].workUserId,
      }).then((res) => {
        this.serviceList = [];
        if (res.code == 1) {
          res.data.forEach((val, ind) => {
            let freeSpecData = JSON.parse(val.freeSpecData);
            this.serviceList.push({
              label: val.goodsName,
              goodsId: val.goodsId,
              serviceTime: val.serviceTime,
              retailPrice: val.retailPrice,
              subList: [],
            });
            if (json) {
              json.bookingList[0].serviceInfo.serviceTime = val.serviceTime;
            }
            if (
              json &&
              json.bookingList.length &&
              json.bookingList[0].goodsId == val.goodsId &&
              !json.bookingList[0].productId &&
              !json.bookingList[0].serviceInfo.specDesc
            ) {
              json.bookingList[0].serviceInfo = this.serviceList[ind];
            }
            if (val.products.length || freeSpecData.length) {
              if (val.products.length && freeSpecData.length) {
                val.products.forEach((product) => {
                  freeSpecData.forEach((free) => {
                    free.specValueList.forEach((value, vindex) => {
                      this.serviceList[ind].subList.push({
                        label: `${val.goodsName}`,
                        otherLabel: `${product.valueContent}-(${free.name}:${value.value})`,
                        goodsId: val.goodsId,
                        productId: product.productId,
                        serviceTime: val.serviceTime,
                        specDesc: `${free.name}:${value.value}`,
                        retailPrice: product.retailPrice,
                      });
                      if (
                        json &&
                        json.bookingList.length &&
                        json.bookingList[0].goodsId == val.goodsId &&
                        json.bookingList[0].productId == product.productId
                      ) {
                        if (
                          json.bookingList[0].serviceInfo.specDesc ==
                          `${free.name}:${value.value}`
                        ) {
                          json.bookingList[0].serviceInfo = this.serviceList[ind].subList[
                            this.serviceList[ind].subList.length - 1
                          ];
                        }
                      }
                    });
                  });
                });
              }
              if (val.products.length && !freeSpecData.length) {
                val.products.forEach((product) => {
                  this.serviceList[ind].subList.push({
                    label: `${val.goodsName}(${product.valueContent})`,
                    otherLabel: `${product.valueContent}`,
                    goodsId: val.goodsId,
                    productId: product.productId,
                    serviceTime: val.serviceTime,
                    retailPrice: product.retailPrice,
                  });
                  if (
                    json &&
                    json.bookingList.length &&
                    json.bookingList[0].goodsId == val.goodsId &&
                    json.bookingList[0].productId == product.productId &&
                    !json.bookingList[0].serviceInfo.specDesc
                  ) {
                    json.bookingList[0].serviceInfo = this.serviceList[ind].subList[
                      this.serviceList[ind].subList.length - 1
                    ];
                  }
                });
              }
              if (!val.products.length && freeSpecData.length) {
                freeSpecData.forEach((free) => {
                  free.specValueList.forEach((value) => {
                    this.serviceList[ind].subList.push({
                      label: `${val.goodsName}`,
                      otherLabel: `${free.name}:${value.value}`,
                      goodsId: val.goodsId,
                      serviceTime: val.serviceTime,
                      specDesc: `${free.name}:${value.value}`,
                      retailPrice: val.retailPrice,
                    });
                    if (
                      json &&
                      json.bookingList[0].goodsId == val.goodsId &&
                      !json.bookingList[0].productId &&
                      json.bookingList[0].serviceInfo.specDesc ==
                        `${free.name}:${value.value}`
                    ) {
                      json.bookingList[0].serviceInfo = this.serviceList[ind].subList[
                        this.serviceList[ind].subList.length - 1
                      ];
                    }
                  });
                });
              }
            }
            console.log(this.serviceList, this.addBookingForm, json);
          });
          if (json) {
            Object.assign(this.addBookingForm, json);
            if (this.addBookingForm.bookingList[0].goodsId) {
              this.findArtisans();
            }
          }
        }
        if (res.code == -1) {
          this.serviceList = [];
        }
        this.isLoadService = false;
      });
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        categoryNatureType: 2,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.menuList = JSON.parse(JSON.stringify(res.data));
          this.menuList.unshift({
            categoryName: "全部",
            goodsCategoryId: "",
          });
        }
      });
    },
    onServiceSel(index) {
      if (this.serviceSel === index) {
        this.serviceSel = "";
        return;
      }
      if (this.serviceList[index].subList.length) {
        this.serviceSel = index;
      } else {
        let item = this.serviceList[index];
        this.onServiceSubSel(item);
      }
    },
    onServiceSubSel(item) {
      this.addBookingForm.bookingList[0].goodsId = item.goodsId;
      this.addBookingForm.bookingList[0].productId = item.productId || "";
      this.addBookingForm.bookingList[0].serviceInfo = item;
      console.log(this.addBookingForm);
      this.addBookingForm.payMoney = item.retailPrice;
      this.isShowBookingPosPop = false;
      if (this.formType != "add" || this.isAddUnassigned) {
        this.findArtisans();
      }
    },
    findArtisans(type) {
      findArtisans({
        goodsId: type == "init" ? "" : this.addBookingForm.bookingList[0].goodsId,
        productId:
          type == "init" ? "" : this.addBookingForm.bookingList[0].productId || "",
        appointmentDate: new Date(this.addBookingForm.appointmentDate).pattern(
          "yyyy-MM-dd"
        ),
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.artisansList = res.data;
          if (
            res.data.findIndex((val) => {
              return val.workUserId == this.addBookingForm.bookingList[0].workUserId;
            }) == -1
          ) {
            this.addBookingForm.bookingList[0].workUserId = "";
          }
          if (type == "init") {
            this.screenArtisansList = res.data;
            // res.data.forEach((val) => {
            //   this.formatArtisansAppointmentStatus(val.workUserId);
            // });
            this.appointmentOrderList();
          }
        }
        if (res.code == -1) {
          this.artisansList = [];
          this.addBookingForm.bookingList[0].workUserId = "";
        }
      });
    },
    appointmentOrderList() {
      appointmentOrderList({
        pageNo: 1,
        row: 9999,
        status: "",
        startDate: this.addBookingForm.appointmentDate.pattern("yyyy-MM-dd"),
        endDate: new Date(
          +new Date(this.addBookingForm.appointmentDate) + 3600 * 1000 * 24
        ).pattern("yyyy-MM-dd"),
        haveBill: 0,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res.data);
          let orderList = [];
          res.data.forEach((order) => {
            if (order.status != 30 && order.status != -10) {
              let findIndex = orderList.findIndex((val) => {
                return val.time == order.startTimePart;
              });
              if (findIndex == -1) {
                orderList.push({
                  appointmentNum: 1,
                  appointmentStatus: 1,
                  time: order.startTimePart,
                  endTime: order.endTimePart,
                });
              } else {
                orderList[findIndex].appointmentNum++;
              }
            }
          });
          this.baseTimeList.forEach((sval, sindex) => {
            let findIndex = orderList.findIndex((val) => {
              return val.time == sval.value;
            });
            if (findIndex != -1) {
              if (orderList[findIndex].appointmentNum >= sval.peopleNum) {
                sval.className = "occupy";
                let ei = 0;
                let isEnd = false;
                while (!isEnd) {
                  ei++;
                  if (!this.baseTimeList[sindex + ei]) {
                    isEnd = true;
                    break;
                  }
                  this.baseTimeList[sindex + ei].className = "occupy";
                  if (
                    this.baseTimeList[sindex + ei].value == orderList[findIndex].endTime
                  ) {
                    isEnd = true;
                  }
                }
              }
            }
          });
        }
        this.filterTimeList();
      });
    },
    hourInputChange(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = Number(e.target.value);
      if (!e.target.value || e.target.value == 0) {
        e.target.value = 0;
      }
      if (e.target.value > 23) {
        e.target.value = 23;
      }
      this.stepInputChange();
    },
    minuteInputChange(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = Number(e.target.value);
      if (!this.addBookingForm.hourStep && (e.target.value < 1 || !e.target.value)) {
        e.target.value = 1;
      }
      if (!e.target.value || e.target.value == 0) {
        e.target.value = 0;
      }
      if (e.target.value > 59) {
        e.target.value = 59;
      }
      this.stepInputChange();
    },
    stepInputChange() {
      timeDisaled = Math.ceil(
        (this.addBookingForm.hourStep * 60 + Number(this.addBookingForm.minuteStep)) /
          timeIntervalNum
      );
      if (this.addBookingForm.startTime) {
        this.computedTime(this.addBookingForm.startTime);
      }
    },
    selTime(index) {
      if (!this.timeList[index].className) {
        let selValue = this.timeList[index].value;
        this.addBookingForm.startTime = selValue;
        this.computedTime(selValue);
      } else {
        this.addBookingForm.startTime = "";
        this.addBookingForm.endTime = "";
      }
    },
    computedTime(selValue) {
      let currentTime = selValue.split("]");
      let isNextDay = currentTime.length == 2;
      if (isNextDay) {
        currentTime = new Date(
          `${new Date(
            +new Date(this.addBookingForm.appointmentDate) + 24 * 60 * 60 * 1000
          ).pattern("yyyy-MM-dd")} ${currentTime[1].trim()}`
        );
      } else {
        currentTime = new Date(
          `${new Date(this.addBookingForm.appointmentDate).pattern(
            "yyyy-MM-dd"
          )} ${currentTime[0].trim()}`
        );
      }
      let timeStep =
        (this.addBookingForm.hourStep * 60 + Number(this.addBookingForm.minuteStep)) *
        60 *
        1000;
      currentTime = new Date(+currentTime + timeStep);
      if (
        new Date(this.addBookingForm.appointmentDate).getDate() != currentTime.getDate()
      ) {
        isNextDay = true;
      }
      this.addBookingForm.endTime = `${isNextDay ? "[次日]" : ""}${currentTime.pattern(
        "HH:mm"
      )}`;
    },
  },
};
</script>

<style lang="less" scoped>
.position-pop {
  position: fixed;
  z-index: 2;
  &.service-list {
    width: 600px;
    height: 300px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    .pop-container {
      height: 100%;
      .header {
        box-sizing: border-box;
        overflow: hidden;
        width: 100%;
        padding: 15px 20px;
        background: #f8f8f8;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-end;
        .el-input,
        .el-select {
          width: 160px;
          margin: 0 5px;
        }
        .input-search {
          width: 200px;
        }
      }
      .list {
        height: calc(100% - 63px);
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        align-content: flex-start;
        padding: 10px;
        box-sizing: border-box;
        .item {
          width: calc(33% - 10px);
          height: 50px;
          margin: 0 10px 10px 0;
          background: #ecf5ff;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          cursor: pointer;
          align-self: flex-start;
          position: relative;
          & > p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 65%;
            flex: 1;
          }
          &:nth-of-type(3n) {
            // margin-right: 0;
          }
          .right {
            text-align: right;
            padding-right: 20px;
            & > p {
              &:first-child {
                color: #409eff;
              }
              &:last-child {
                font-size: 12px;
                color: #969799;
              }
            }
          }
          .el-icon-caret-bottom {
            font-size: 16px;
            position: absolute;
            top: 50%;
            right: 5px;
            transform: translateY(-50%) rotate(0);
            transition: all 0.2s;
          }
          .sublist {
            position: absolute;
            left: 0;
            right: 0;
            top: 100%;
            height: 0;
            background: #fff;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
            overflow: auto;
            transition: all 0.2s;
            z-index: 2;
            .sub-item {
              display: flex;
              justify-content: space-between;
              padding: 0 10px;
              line-height: 30px;
              &:hover {
                background: #ecf5ff;
              }
              span {
                font-size: 12px;
                &:first-child {
                  flex: 1;
                }
                &:last-child {
                  color: #409eff;
                }
              }
            }
          }
          &.active {
            .sublist {
              height: 150px;
            }
            .el-icon-caret-bottom {
              transform: translateY(-50%) rotate(180deg);
            }
          }
        }
      }
    }
  }
  &.time-list {
    width: 500px;
    height: 300px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    .pop-container {
      height: 100%;
      .list {
        height: calc(100% - 50px);
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        padding: 10px 0;
        box-sizing: border-box;
        .item {
          width: calc(12.5%);
          font-size: 15px;
          text-align: center;
          height: 40px;
          user-select: none;
          cursor: pointer;
          &.disabled {
            color: #969799;
            cursor: not-allowed;
          }
          &.occupy {
            color: #969799;
            text-decoration: line-through;
            cursor: not-allowed;
          }
          p {
            line-height: 1;
          }
        }
      }
      .footer {
        height: 50px;
        display: flex;
        padding: 0 10px;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-top: 1px solid #969799;
        .unsel {
          color: #969799;
        }
      }
    }
  }
}
.add-booking-form {
  .sel-time-button {
    margin-left: 20px;
  }
  .hour-minute {
    display: flex;
    align-items: center;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .service-info {
    font-size: 14px;
    line-height: 1.5;
    p {
      color: #999;
      &:first-child {
        color: #000;
      }
    }
  }
}
</style>

<style lang="less">
.add-booking-form {
  .width260 {
    width: 260px;
  }

  .hour-minute {
    .el-input-group__append,
    .el-input-group__prepend {
      background-color: #f5f7fa;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding: 0 20px;
      width: 1px;
      white-space: nowrap;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
    }
  }
  .el-input-group__prepend {
    .el-input--suffix {
      width: 100px;
    }
  }
}
</style>
